export default function ElementContainer({ title = "", subtitle = "", children, classNames = "" }) {
    return (
        <div className={`cot-elem-container component-container-type ${classNames || ""}`}>
            {title && <h2 className="cot-elem-container-title title-4">{title}</h2>}
            {subtitle && <p className="cot-elem-container-subtitle paragraph">{subtitle}</p>}

            <div className="cot-elem-container-content">{children}</div>
        </div>
    );
}
